export default __webpack_public_path__ + "static/media/logo-vinted.10b0caad.png";